import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueSession from 'vue-session';
import Buefy from 'buefy'
import { ValidationProvider } from 'vee-validate';
import i18n from '@/plugins/i18n'
import InputFacade from 'vue-input-facade'

Vue.use(InputFacade)

import ApiClient from './utils/ApiClient';

import './assets/scss/main.scss'

//install lodash
const lodash = require('lodash');
Vue.prototype._lodash = lodash;

Vue.use(Buefy);

Vue.use(VueSession, {
    persist: true,
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.config.productionTip = false;
Vue.prototype.$apiClient = ApiClient;

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
